const steps = [
    { title: "Creá tu cuenta", body: "Te registrás con tu mail o con Google y completás los datos de tu negocio. Arrancás gratis." },
    { title: "Cargá tus productos", body: "Armá categorías y sumá productos o servicios con foto, descripción y precio. Elegí los colores de tu catálogo." },
    { title: "Compartí tu QR", body: "Descargalo para mesas, mostrador o vidriera, o pasá el link por redes. Si cambiás un precio, el QR sigue siendo el mismo." }
];

const Steps = () => {
  return (
    <section className="lp-section lp-steps">
        <div className="lp-container">
            <h2 data-reveal>Listo en tres pasos</h2>
            <ol className="lp-steps-list">
                {
                    steps.map((step, i) => (
                        <li key={step.title} className="lp-step" data-reveal style={{ "--d": (i * 120) + "ms" }}>
                            <span className="lp-step-num">{i + 1}</span>
                            <div>
                                <h3>{step.title}</h3>
                                <p>{step.body}</p>
                            </div>
                        </li>
                    ))
                }
            </ol>
        </div>
    </section>
  )
}

export default Steps
